"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeCell = exports.DateTimeCellContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
const library_1 = require("library");
exports.DateTimeCellContainer = styled_components_1.default.span `
  ${style_1.default.Text.Definition.Truncate};
`;
const DateTimeCell = ({ value, }) => {
    const date = (0, library_1.toDateTime)(value);
    return ((0, jsx_runtime_1.jsx)(exports.DateTimeCellContainer, { children: (0, library_1.displayDateTime)(date, { format: library_1.ADMIN_DATE_TIME_FORMAT }) }));
};
exports.DateTimeCell = DateTimeCell;
